<div class="toolbar-wrapper">
  <div class="glxy-page-title-container">
    <!-- Optionally show nav toggle in toolbar -->
    <ng-container *ngIf="showNavToggle">
      <button
        mat-icon-button
        (click)="this.toggleNav()"
        class="glxy-page-nav-toggle"
        matTooltip="{{ 'GALAXY.PAGE.TOGGLE_MENU' | translate }}"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </ng-container>

    <!-- Back Button/Crumbing -->
    <ng-content select="glxy-page-nav"></ng-content>

    <!-- Page Title and Title actions -->
    <ng-content select="glxy-page-title"></ng-content>
  </div>

  <div class="glxy-page-action-container">
    <!-- Actions that are beside the page title -->
    <div class="glxy-page-title-actions-container">
      <ng-content select="glxy-page-title-actions"></ng-content>
    </div>

    <!-- Main actions. On the far right -->
    <div class="glxy-page-main-actions-container">
      <ng-content select="glxy-page-actions"></ng-content>
    </div>

    <div class="glxy-page-extra-content">
      <!-- Any other content added to <glxy-page-toolbar> goes here. -->
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-container *ngIf="showExtendedToolbar">
  <div class="galaxy-page-extended-toolbar-container">
    <ng-content select="glxy-page-extended-toolbar"></ng-content>
  </div>
</ng-container>
